import React from 'react';
import FirebaseDB from './firebase';

const FourZeroFour = () => {
    new FirebaseDB("FourZeroFour").upload("FourZeroFour", { page: window.location.href });//constructor logs firebase source

    return (
        <div id="fourzerofour" className="d-flex align-self-center justify-content-center">
            <div className="d-flex">
                <div id="fourzerofour-content" className="text-center justify-content-center">
                    <img src="/images/crapaud.jpg" height="200px"></img>
                    <p className="display-3"><strong>404</strong></p>
                    <p className="display-4">Uh oh, crapaud smoke he pipe!</p>
                    <p>The page you are looking for doesn't exist or another error occurred.<br /><a href=" javascript:history.back()">Go back</a>, or head over to <a href="/">bssantigua.com</a> to choose a new direction.</p>
                </div>
            </div>
        </div>
    )
}

export default FourZeroFour;